import { nationalitiesNamesZH } from "./nationalities_zh"
import { nationalities } from "./nationalities"
export const zh = {
  //Footer
  "page.footer.exchange": "交换",
  "page.footer.convert": "转变",
  "page.footer.launchpad": "发射台",
  "page.footer.wallet": "钱包",
  "page.footer.support": "支持",
  "page.footer.requestForm": "申请表",
  "page.footer.contactSupport": "联系支持",
  "page.footer.resources": "资源",
  "resource.phone.new_number.please_modify_number_first":
    "您输入了新号码，请先修改。",
  "page.footer.downloads": "下载",
  "page.footer.mobileApplication": "流动应用程式",
  "page.footer.buyCrypto": "购买加密货币",
  "page.footer.referral": "转介",
  "page.footer.listingTranding": "Listing Tranding",
  "page.footer.learn": "学习",
  "page.footer.whatsTrending": "什么是趋势",
  "page.footer.productNews": "产品新闻",
  "page.footer.events": "事件",
  "page.footer.university": "大学",
  "page.footer.research": "研究",
  "page.footer.marketUpdate": "市场更新",
  "page.footer.company": "公司",
  "page.footer.aboutUs": "关于我们",
  "page.footer.careers": "招贤纳士",
  "page.footer.news": "消息",
  "page.footer.security": "安全",
  "page.footer.community": "社区",
  "page.footer.announcements": "公告",
  "page.footer.allRightsReserved": "版权所有",
  "page.footer.privacy": "隐私",
  "page.footer.terms": "条款",
  "page.footer.siteMap": "网站地图",
  "page.footer.iosDownload": "下载在",
  "page.footer.androidDownload": "穿上它",

  // Added :
  "page.header.navbar.blogs": "博客",
  "page.header.navbar.launchpad": "发射台",
  "page.header.navbar.exchange": "交换",
  "page.header.navbar.markets": "市场",
  "page.header.navbar.convert": "转变",
  // 14 FEB
  "page.header.signInToWenbit": "登录 WealthTech",

  "page.markets.trade.marketCoins": "市场硬币",

  "page.markets.trade.buy": "买",
  "page.markets.trade.sell": "卖",
  "page.markets.trade.limit": "限制",
  "page.markets.trade.market": "市场",
  "page.markets.trade.quantity": "数量",
  "page.markets.trade.buyFor": "为...买",
  "page.markets.trade.sellFor": "卖为",
  "page.markets.trade.total": "全部的",
  "page.markets.trade.fee": "费用",
  "page.markets.trade.quickBuy": "快速购买",
  "page.markets.trade.quickSell": "快速销售",

  "page.markets.rows.name": "硬币名称",
  "page.markets.rows.price": "硬币价格",
  "page.markets.rows.24": "24%",
  "page.markets.rows.24High": "24小时最高价",
  "page.markets.rows.24Low": "24小时最低价",
  "page.markets.rows.chart": "图表",

  "page.header.navbar.signIn": "登录",
  "page.header.navbar.signUp": "注册",
  "page.header.navbar.trade": "交易",
  "page.header.navbar.wallets": "钱包",
  "page.header.navbar.openOrders": "未成交订单",
  "page.header.navbar.history": "历史",
  "page.header.navbar.profile": "个人资料",
  "page.header.navbar.logout": "退出",
  "page.body.copy.success": "成功",
  "page.body.trade.header.markets": "市场",
  "page.body.trade.header.markets.content.market": "市场",
  "page.body.trade.header.markets.content.pair": "交易对",
  "page.body.trade.header.markets.content.price": "价格",
  "page.body.trade.header.markets.content.last_price": "最新成交价",
  "page.body.trade.header.markets.content.change": "24小时的变化",
  "page.body.trade.header.markets.content.search": "搜索",
  "page.body.trade.header.markets.content.volume": "交易量",
  "page.body.trade.header.newOrder": "创建订单",
  "page.body.trade.header.newOrder.content.tabs.buy": "买入",
  "page.body.trade.header.newOrder.content.tabs.sell": "卖出",
  "page.body.trade.header.newOrder.content.orderType": "订单类型",
  "page.body.trade.header.newOrder.content.orderType.limit": "限价单",
  "page.body.trade.header.newOrder.content.orderType.market": "市价单",
  "page.body.trade.header.newOrder.content.price": "价格",
  "page.body.trade.header.newOrder.content.amount": "数量",
  "page.body.trade.header.newOrder.content.total": "总计",
  "page.body.trade.header.newOrder.content.available": "可用",
  "page.body.trade.header.newOrder.content.estimatedFee": "费用",
  "page.body.trade.header.marketDepths": "市场深度",
  "page.body.trade.header.marketDepths.content.price": "价格",
  "page.body.trade.header.marketDepths.content.volume": "交易量:",
  "page.body.trade.header.marketDepths.content.cumulativeVolume": "累积量:",
  "page.body.trade.header.marketDepths.content.cumulativeValue": "累积值:",
  "page.body.trade.header.asks": "卖出价",
  "page.body.trade.header.bids": "买入价",
  "page.body.trade.orderbook": "订单簿",
  "page.body.trade.orderbook.header.price": "价格",
  "page.body.trade.orderbook.header.amount": "数量",
  "page.body.trade.orderbook.header.volume": "交易量",
  "page.body.trade.header.recentTrades": "近期交易记录",
  "page.body.trade.header.recentTrades.content.time": "时间",
  "page.body.trade.header.recentTrades.content.price": "价格",
  "page.body.trade.header.recentTrades.content.amount": "数量",
  "page.body.trade.header.openOrders": "未成交订单",
  "page.body.trade.header.openOrders.content.date": "日期",
  "page.body.trade.header.openOrders.content.state": "状态",
  "page.body.trade.header.openOrders.content.price": "价格",
  "page.body.trade.header.openOrders.content.amount": "数量",
  "page.body.trade.header.openOrders.content.total": "总计",
  "page.body.trade.header.openOrders.content.filled": "填充",
  "page.body.wallets.estimated_value": "估计值",
  "page.body.wallets.locked": "已锁定",
  "page.body.wallets.balance": "余额",
  "page.body.wallets.tabs.deposit": "充值",
  "page.body.wallets.tabs.deposit.ccy.message.submit":
    "请使用以下地址充值，您的充值将在区块链得到6个确认后完成",
  "page.body.wallets.tabs.deposit.ccy.message.address": "钱包地址充值",
  "page.body.wallets.tabs.deposit.ccy.message.button": "复制",
  "page.body.wallets.tabs.deposit.ccy.message.success": "地址已复制",
  "page.body.wallets.tabs.deposit.ccy.message.error":
    "正在生成地址，请稍等片刻，然后重新打开",
  "page.body.wallets.tabs.deposit.fiat.message1": "你可以在银行存入此凭证",
  "page.body.wallets.tabs.deposit.fiat.message2":
    "请使用以下信息完成银行付款。您的充值将在两个工作日内反映在您的帐户中。",
  "page.body.wallets.tabs.deposit.fiat.bankName": "银行名称",
  "page.body.wallets.tabs.deposit.fiat.accountNumber": "帐号",
  "page.body.wallets.tabs.deposit.fiat.accountName": "帐户姓名",
  "page.body.wallets.tabs.deposit.fiat.branchNumber": "支行编号",
  "page.body.wallets.tabs.deposit.fiat.branchAddress": "支行地址",
  "page.body.wallets.tabs.deposit.fiat.swiftCode": "交换码",
  "page.body.wallets.tabs.deposit.fiat.phoneNumber": "电话号码",
  "page.body.wallets.tabs.deposit.fiat.referenceCode": "您的参考代码",
  "page.body.wallets.tabs.deposit.fiat.etrans_message1":
    "您可以使用email transfer 存入",
  "page.body.wallets.tabs.deposit.fiat.etrans_message2":
    "请使用以下email地址来做e-transfer",
  "page.body.wallets.tabs.deposit.fiat.etrans_email": "email",
  "page.body.wallets.table.pending": "等待中",
  "page.body.wallets.tabs.deposit.fiat.admin":
    " 如果您需要充值，请联系客服团队",
  "page.body.wallets.tabs.deposit.fiat.email": " email",
  "page.body.wallets.tabs.withdraw": "提现",
  "page.body.wallets.tabs.withdraw.content.address": "提现地址",
  "page.body.wallets.tabs.withdraw.content.amount": "提现数量",
  "page.body.wallets.tabs.withdraw.content.code2fa": "6位数的Google身份验证码",
  "page.body.wallets.tabs.withdraw.content.fee": "费用",
  "page.body.wallets.tabs.withdraw.content.total": "总提现数量",
  "page.body.wallets.tabs.withdraw.content.button": "提现",
  "page.body.wallets.tabs.withdraw.content.addressPlaceholder": "提现地址",
  "page.body.wallets.tabs.withdraw.modal.confirmation": "确认",
  "page.body.wallets.tabs.withdraw.modal.message1": "您将收到",
  "page.body.wallets.tabs.withdraw.modal.button.cancel": "取消",
  "page.body.wallets.tabs.withdraw.modal.button.withdraw": "提现",
  "page.body.wallets.tabs.withdraw.content.enable2fa":
    "您需要启用Google身份验证以便提现！",
  "page.body.wallets.tabs.withdraw.content.enable2faButton":
    "启用Google身份验证",
  "page.body.openOrders.tab.all": "全部",
  "page.body.openOrders.tab.open": "未成交",
  "page.body.openOrders.header.orderType": "订单类型",
  "page.body.openOrders.header.orderType.buy.market": "市场价买入",
  "page.body.openOrders.header.orderType.buy.limit": "限价买入",
  "page.body.openOrders.header.orderType.sell.market": "市场价卖出",
  "page.body.openOrders.header.orderType.sell.limit": "限价卖出",
  "page.body.openOrders.header.pair": "交易对",
  "page.body.openOrders.header.amount": "数量",
  "page.body.openOrders.header.price": "价格",
  "page.body.openOrders.header.executed": "完成",
  "page.body.openOrders.header.remaining": "剩余",
  "page.body.openOrders.header.costRemaining": "剩余成本",
  "page.body.openOrders.header.status": "状态",
  "page.body.openOrders.content.status.done": "完成",
  "page.body.openOrders.content.status.approve": "Pending",
  "page.body.openOrders.content.status.reject": "Rejected",
  "page.body.openOrders.content.status.wait": "等待",
  "page.body.openOrders.content.status.cancel": "取消",
  "page.body.openOrders.header.button.cancelAll": "取消全部",
  "page.body.history.deposit": "充值记录",
  "page.body.history.deposit.header.txid": "交易ID",
  "page.body.history.deposit.header.date": "日期",
  "page.body.history.deposit.header.currency": "货币",
  "page.body.history.deposit.header.amount": "数量",
  "page.body.history.deposit.header.status": "状态",
  "page.body.history.deposit.content.status.accepted": "已接受",
  "page.body.history.deposit.content.status.collected": "已收集",
  "page.body.history.deposit.content.status.submitted": "已提交",
  "page.body.history.deposit.content.status.canceled": "已取消",
  "page.body.history.deposit.content.status.rejected": "拒绝",
  "page.body.history.deposit.content.status.skipped": "跳过",
  "page.body.history.withdraw": "提现记录",
  "page.body.history.withdraw.header.id": "ID",
  "page.body.history.withdraw.header.date": "日期",
  "page.body.history.withdraw.header.currency": "货币",
  "page.body.history.withdraw.header.address": "地址",
  "page.body.history.withdraw.header.amount": "数量",
  "page.body.history.withdraw.header.fee": "费用",
  "page.body.history.withdraw.header.status": "状态",
  "page.body.history.withdraw.content.status.prepared": "准备",
  "page.body.history.withdraw.content.status.submitted": "已提交",
  "page.body.history.withdraw.content.status.canceled": "已取消",
  "page.body.history.withdraw.content.status.accepted": "已接受",
  "page.body.history.withdraw.content.status.suspected": "被怀疑",
  "page.body.history.withdraw.content.status.rejected": "拒绝",
  "page.body.history.withdraw.content.status.processing": "处理中",
  "page.body.history.withdraw.content.status.succeed": "成功",
  "page.body.history.withdraw.content.status.failed": "失败",
  "page.body.history.withdraw.content.status.confirming": "确认",
  "page.body.history.withdraw.content.status.errored": "Error",
  "page.body.history.trade": "交易记录",
  "page.body.history.trade.header.id": "ID",
  "page.body.history.trade.header.date": "日期",
  "page.body.history.trade.header.side": "操作",
  "page.body.history.trade.content.side.buy": "买入",
  "page.body.history.trade.content.side.sell": "卖出",
  "page.body.history.trade.header.market": "市场",
  "page.body.history.trade.header.price": "价格",
  "page.body.history.trade.header.funds": "基金",
  "page.body.history.trade.header.amount": "数量",
  "page.body.history.trade.header.balance": "余额",
  "page.body.profile.kyc.content": "为遵守规定，参与者必须通过身份验证",
  "page.body.profile.kyc.content.notice": "提现需要通过身份验证",
  "page.body.profile.kyc.button.success": "身份验证已通过",
  "page.body.profile.kyc.button.pending": "身份验证待审核",
  "page.body.profile.kyc.button.fail": "开始身份验证",
  "page.body.profile.header.account": "帐号",
  "page.body.profile.header.account.content.password": "密码",
  "page.body.profile.header.account.content.password.button.change": "更改",
  "page.body.profile.header.account.content.password.old": "旧密码",
  "page.body.profile.header.account.content.password.new": "新密码",
  "page.body.profile.header.account.content.password.button.save": "保存",
  "page.body.profile.header.account.content.password.button.cancel": "取消",
  "page.body.profile.header.account.content.password.conf": "确认密码",
  "page.body.profile.header.account.content.password.dont.match": "密码不匹配",
  "page.body.profile.header.account.content.password.change.success": "成功",
  "page.body.profile.header.account.content.password.change": "更改密码",
  "page.body.profile.header.account.content.twoFactorAuthentication":
    "双因素身份验证",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.enable":
    "已启用",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.disable":
    "已禁用",
  "page.body.profile.header.account.content.twoFactorAuthentication.header":
    "Google身份验证",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.1":
    "下载并安装Google身份验证 ",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.or":
    "或 ",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.2":
    "扫描二维码或者使用密码:",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.3":
    "* 保存这个密码到安全的地方， 这个密码用于生成Google身份验证码，是您可以从不同的设备访问.",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.mfa":
    "密码",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.4":
    "输入软件生成的身份验证码",
  "page.body.profile.header.account.content.twoFactorAuthentication.subHeader":
    "6位Google身份验证器代码",
  "page.body.profile.header.account.content.twoFactorAuthentication.enable":
    "启用",
  "page.body.profile.header.account.content.twoFactorAuthentication.disable":
    "禁用",
  "page.body.profile.header.account.content.twoFactorAuthentication.modalBody":
    "请联系管理员禁用它。",
  "page.body.profile.header.account.content.twoFactorAuthentication.modalHeader":
    "启用google身份验证",
  "page.body.profile.header.account.profile": "个人资料验证",
  "page.body.profile.header.account.profile.email.title": "经过电子邮件验证",
  "page.body.profile.header.account.profile.email.message": "不允许充值和提现",
  "page.body.profile.header.account.profile.phone.unverified.title": "手机验证",
  "page.body.profile.header.account.profile.phone.title": "手机已验证",
  "page.body.profile.header.account.profile.phone.message": "允许充值和交易",
  "page.body.profile.header.account.profile.identity.unverified.title":
    "手机验证",
  "page.body.profile.header.account.profile.identity.title": "身份验证",
  "page.body.profile.header.account.profile.identity.message": "允许提现",
  "page.body.profile.header.referralProgram": "推荐计划",
  "page.body.profile.content.copyLink": "复制链接",
  "page.body.profile.apiKeys.header": "我的API密钥对",
  "page.body.profile.apiKeys.header.create": "创建新的密钥对",
  "page.body.profile.apiKeys.noOtp": "请启用google身份验证",
  "page.body.profile.apiKeys.show": "显示",
  "page.body.profile.apiKeys.noKeys": "您没有API密钥对",
  "page.body.profile.apiKeys.modal.btn.show": "显示",
  "page.body.profile.apiKeys.modal.btn.create": "确认",
  "page.body.profile.apiKeys.modal.btn.copy": "复制",
  "page.body.profile.apiKeys.modal.btn.activate": "激活",
  "page.body.profile.apiKeys.modal.btn.disabled": "关闭",
  "page.body.profile.apiKeys.modal.btn.delete": "删除",
  "page.body.profile.apiKeys.modal.header": "google身份验证",
  "page.body.profile.apiKeys.modal.created_header": "创建",
  "page.body.profile.apiKeys.modal.access_key": "访问密钥",
  "page.body.profile.apiKeys.modal.secret_key": "私钥",
  "page.body.profile.apiKeys.modal.secret_key_info":
    "这个消息只会显示一次，一旦丢失无法找回。",
  "page.body.profile.apiKeys.modal.secret_key_store": "请妥善保存.",
  "page.body.profile.apiKeys.modal.note": "注",
  "page.body.profile.apiKeys.modal.note_content": `为了避免您的资产丢失，请不要将您的密钥告诉别人.\
 如果您忘记了私钥，请删除后重新创建新的密钥对.`,
  "page.body.profile.apiKeys.modal.title": "输入google身份验证码",
  "page.body.profile.apiKeys.modal.label": "6位的google身份验证码",
  "page.body.profile.apiKeys.modal.placeholder": "输入验证码",
  "page.body.profile.apiKeys.table.header.kid": "Kid",
  "page.body.profile.apiKeys.table.header.algorithm": "算法",
  "page.body.profile.apiKeys.table.header.state": "状态",
  "page.body.profile.apiKeys.table.header.created": "创建",
  "page.body.profile.apiKeys.table.header.updated": "更新",
  "success.api_keys.fetched": "成功获取API密钥对",
  "success.api_keys.created": "API密钥对已创建",
  "success.api_keys.copied.access": "访问密钥已复制",
  "success.api_keys.copied.secret": "私钥已复制",
  "success.api_keys.updated": "API密钥对已更新",
  "success.api_keys.deleted": "API密钥对已删除",
  "page.body.profile.header.accountActivity": "帐户活动",
  "page.body.profile.header.accountActivity.content.date": "日期",
  "page.body.profile.header.accountActivity.content.addressip": "IP地址",
  "page.body.profile.header.accountActivity.content.action": "行为",
  "page.body.profile.header.accountActivity.content.result": "结果",
  "page.body.profile.header.accountActivity.content.userAgent": "用户代理",
  "page.body.profile.content.action.login": "登录",
  "page.body.profile.content.action.logout": "退出",
  "page.body.profile.content.action.request2fa": "申请2FA的QR码",
  "page.body.profile.content.action.enable2fa": "启用2FA",
  "page.body.profile.content.action.login.2fa": "使用2FA登录",
  "page.body.profile.content.action.requestPasswordReset": "请求密码重置",
  "page.body.profile.content.action.passwordReset": "密码重置",
  "page.body.profile.content.result.succeed": "成功",
  "page.body.profile.content.result.failed": "失败",
  "page.body.kyc.phone.head": "让我们验证您的手机",
  "page.body.kyc.phone.enterPhone": "输入您的电话号码",
  "page.body.kyc.phone.phoneNumber": "电话号码",
  "page.body.kyc.phone.enterCode": "输入您收到的代码",
  "page.body.kyc.phone.code": "短信代码",
  "page.body.kyc.phone.send": "发送代码",
  "page.body.kyc.phone.resend": "重新发送代码",
  "page.body.kyc.identity.head": "身份验证",
  "page.body.kyc.document.head": "文档验证",
  "page.body.kyc.identity.firstName": "名字",
  "page.body.kyc.identity.lastName": "姓氏",
  "page.body.kyc.identity.dateOfBirth": "出生日期 日/月/年",
  "page.body.kyc.identity.residentialAddress": "住址",
  "page.body.kyc.identity.city": "城市",
  "page.body.kyc.identity.postcode": "邮政编码",
  "page.body.kyc.identity.nationality": "国籍",
  "page.body.kyc.identity.CoR": "居住国家",
  "page.body.kyc.documents.expiryDate": "到期日 日/月/年",
  "page.body.kyc.documents.drag": "拖放或浏览文件",
  "page.body.kyc.documents.maxFile": "最大文件大小为20MB",
  "page.body.kyc.documents.maxNum": "最大文件数为5",
  "page.body.kyc.documents.files": "允许的文件类型: jpg, jpeg, png",
  "page.body.kyc.documents.upload": "上传您的身份证照片",
  "page.body.kyc.documents.select.passport": "护照",
  "page.body.kyc.documents.select.identityCard": "身份证",
  "page.body.kyc.documents.select.driverLicense": "驾驶执照",
  "page.body.kyc.documents.select.utilityBill": "水电费账单",
  "page.body.kyc.documents.number": ": 数字",
  "page.body.kyc.documentsType": "文档类型",
  "page.body.kyc.next": "下一步",
  "page.body.kyc.submit": "提交",
  "page.body.kyc.head.phone": "手机验证",
  "page.body.kyc.head.identity": "身份验证",
  "page.body.kyc.head.document": "文件验证",
  "page.body.kyc.error": "請驗證您的 KYC",
  "page.footer.legalDocuments": "法律文件",
  "page.footer.faq": "常见问题",
  "page.header.signIn": "登录",
  "page.header.signIn.email": "电子邮件",
  "page.header.signIn.password": "密码",
  "page.header.signIn.password.message.error": "无效的密码",
  "page.header.signIn.receiveConfirmation": "没有收到您的确认电子邮件",
  "page.header.signIn.forgotPassword": "忘记密码？",
  "page.header.signIn.resetPassword.title": "重置密码",
  "page.header.signIn.resetPassword.newPassword": "新密码",
  "page.header.signIn.resetPassword.repeatPassword": "重复密码",
  "page.header.signIn.resetPassword.button": "更改",
  "page.header.signIn.resetPassword.error": "密码不匹配",
  "page.header.signUp": "注册",
  "page.header.signUp.email": "电子邮件 *",
  "page.header.signUp.email.message.error": "电子邮件无效",
  "page.header.signUp.usernameLength.message.error":
    "用户名必须至少4个字符，最多20个字符",
  "page.header.signUp.password": "密码 *",
  "page.header.signUp.password.message.error":
    "密码至少8位，包含一个大写字母，一个小写字母和一个数字",
  "page.header.signUp.confirmPassword": "确认密码*",
  "page.header.signUp.confirmPassword.message.error": "密码不匹配",
  "page.header.signUp.referalCode": "可选的推荐代码",
  "page.header.signUp.terms": "我同意服务条款的所有陈述",
  "page.header.signUp.modal.header": "验证您的电子邮件地址",
  "page.header.signUp.modal.body":
    "请查找收件箱中的邮件，执行操作以完成注册；如果找不到该邮件，请查看您的垃圾邮件。",
  "page.resendConfirmation": "重新发送邮件",
  "page.forgotPassword": "忘记密码",
  "page.forgotPassword.message": "请输入邮箱重置密码",
  "page.password2fa": "google身份验证",
  "page.password2fa.message": "输入google身份验证码",
  "page.forgotPassword.email": "电子邮件",
  "page.forgotPassword.send": "发送",
  "page.noDataToShow": "没有要显示的数据...",
  "page.modal.withdraw.success": "成功！",
  "page.modal.withdraw.success.message.content":
    "您的提现已成功提交。 请等待接收 很少有强制确认完成此次交易。",
  "page.modal.withdraw.success.button": "确定",
  // success messages
  "success.logout": "注销成功",
  "success.documents.accepted": "您的文档已经成功接收。",
  "success.documents.fetched": "文档获取成功",
  "success.withdraw.action": "提现成功",
  "success.otp.enabled": "google身份验证已经启用",
  "success.password.changed": "密码已更改",
  "success.password.forgot": "重置密码的链接已发到您的邮箱",
  "success.password.changed.successfuly": "密码已更改",
  "success.order.canceled": "订单已经取消",
  "success.order.canceled.all": "所有订单已经取消",
  "success.order.created": "订单已经创建",
  "success.phone.verification.send": "验证码已经发到您的手机",
  "success.phone.confirmed": "您的电话已经确认",
  "success.message.sent": "消息已经发出",
  "success.email.confirmed": "您的邮箱地址已经确认",
  // error messages
  // barong
  "resource.labels.private": "不能更新标签",
  "resource.user.no_activity": "没有活动记录",
  "resource.profile.not_exist": "用户资料不存在",
  "resource.profile.exist": "用户资料已不存在",
  "resource.api_key.2fa_disabled": "账号必须先启用google身份验证",
  "resource.api_key.missing_otp": "账号已经启用google身份验证，但验证码缺失",
  "resource.api_key.invalid_otp": "身份验证码无效",
  "resource.phone.twillio": "Twilio客户端出问题",
  "resource.phone.invalid_num": "无效的电话号码",
  "resource.phone.exists": "电话号码已经存在",
  "resource.phone.number_exist": "电话号码已经存在",
  "resource.phone.verification_invalid": "验证码无效",
  "resource.documents.limit_reached": "已经达到最大文档数",
  "resource.documents.limit_will_be_reached": "文档数量将达到上传的限制",
  "resource.otp.already_enabled": "google身份验证已经启用",
  "resource.otp.invalid": "身份验证码无效",
  "resource.password.doesnt_match": "新密码不匹配",
  "resource.password.prev_pass_not_correct": "旧密码不正确",
  "resource.password.no_change_provided": "新密码不能和旧密码一样",
  "resource.document.empty_doc_expire": "过期日期不对",
  "password.requirements": "密码不符合最低要求",
  "password.password.password_strength": "密码太弱,请增加密码长度或复杂度",

  "email.taken": "邮箱已经被占用",
  "email.invalid": "不合规电邮",

  "identity.user.invalid_referral_format": "无效的推荐格式",
  "identity.user.referral_doesnt_exist": "推荐号不存在",
  "identity.user.active_or_doesnt_exist": "用户不存在或已经激活",
  "identity.password.user_doesnt_exist": "用户不存在",
  "identity.user.passwords_doesnt_match": "密码不匹配",
  "identity.user.utilized_token": "JWT 已经被使用",
  "identity.session.invalid_login_params": "无效的邮箱或密码",
  "identity.session.invalid": "无效的会话",
  "identity.captcha.required": "要求验证码",
  "identity.captcha.mandatory_fields": "必须填写的字段",
  "identity.session.not_active": "您的账号没有激活",
  "identity.session.banned": "您的账号被禁止",
  "identity.session.invalid_params": "无效的邮箱或密码",
  "identity.session.missing_otp": "缺少身份验证码",
  "identity.session.invalid_otp": "身份验证码无效",
  "first_name.invalid": "名 无效",
  "last_name.invalid": "姓 无效",
  "city.invalid": "城市 无效",
  "postcode.invalid": "邮编 无效",
  "address.invalid": "地址 无效",
  "first_name.blank": "名 字段是空白",
  "last_name.blank": "姓 字段是空白",
  "dob.blank": "生日 字段是空白",
  "address.blank": "地址 字段是空白",
  "city.blank": "城市 字段是空白",
  "country.blank": "国家 字段是空白",
  "postcode.blank": "邮编 字段是空白",
  "country.must have alpha2 or alpha3 format": "国家必须有国家代码",
  "totp.error": "身份验证码无效",
  "record.not_found": "记录没有找到",
  "jwt.decode_and_verify": "JWT验证失败",
  "authz.invalid_session": "cookies解析失败",
  "authz.user_not_active": "用户没有激活",
  "authz.invalid_signature": "API密钥签名无效",
  "authz.apikey_not_active": "API密钥对没有激活",
  "authz.disabled_2fa": "API密钥对没有激活",
  "authz.invalid_api_key_headers": "缺少API密钥头部信息",
  "authz.permission_denied": "路径在黑名单里",
  "authz.unexistent_apikey": "X-Auth-Apikey 头无效",
  // validation errors
  // identity module
  "identity.user.missing_email": "缺少邮箱地址",
  "identity.user.empty_email": "邮箱地址是空的",
  "identity.user.missing_password": "缺少密码",
  "identity.user.empty_password": "密码是空的",
  "identity.user.missing_token": "缺少Token",
  "identity.user.empty_token": "Token是空的",
  "identity.user.missing_reset_password_token": "缺少重置密码的token",
  "identity.user.empty_reset_password_token": "重置密码的token是空的",
  "identity.user.missing_confirm_password": "缺少确认密码",
  "identity.user.empty_confirm_password": "确认密码是空的",
  "identity.session.missing_emai": "缺少邮箱地址",
  "identity.session.missing_password": "缺少密码",
  "identity.session.invalid_captcha_format": "无效的验证码",
  // resource module
  "resource.otp.missing_code": "缺少身份验证码",
  "resource.otp.empty_code": "身份验证码是空的",
  "resource.labels.missing_key": "缺少密钥",
  "resource.labels.empty_key": "密钥是空的",
  "resource.labels.missing_value": "缺少值",
  "resource.labels.empty_value": "值是空的",
  "resource.documents.missing_doc_expire": "缺少文档过期时间",
  "resource.documents.empty_doc_expire": "文档过期时间是空的",
  "resource.documents.missing_doc_type": "缺少文档类型",
  "resource.documents.empty_doc_type": "文档类型是空的",
  "resource.documents.missing_doc_number": "缺少文档号码",
  "resource.documents.empty_doc_number": "文档号码是空的",
  "resource.documents.missing_upload": "缺少上传文档",
  "resource.user.missing_topic": "缺少题目",
  "resource.user.empty_topic": "题目是空的",
  "resource.user.missing_old_password": "缺少旧密码",
  "resource.user.empty_old_password": "旧密码是空的",
  "resource.user.missing_new_password": "缺少新密码",
  "resource.user.empty_new_password": "新密码是空的",
  "resource.user.missing_confirm_password": "缺少新密码确认",
  "resource.user.empty_confirm_password": "新密码确认是空的",
  "resource.profile.missing_first_name": "缺少名",
  "resource.profile.missing_last_name": "缺少姓",
  "resource.profile.missing_dob": "缺少生日",
  "resource.profile.missing_address": "缺少地址",
  "resource.profile.missing_postcode": "缺少邮编",
  "resource.profile.missing_city": "缺少城市",
  "resource.profile.missing_country": "缺少国家",
  "resource.api_key.missing_algorithm": "缺少算法",
  "resource.api_key.empty_algorithm": "算法是空的",
  "resource.api_key.empty_kid": "KID 是空的",
  "resource.api_key.empty_scope": "Scope 是空的",
  "resource.api_key.missing_totp": "缺少TOTP ",
  "resource.api_key.empty_totp": "TOTP是空的",
  "resource.api_key.missing_kid": "缺少KID",
  "resource.api_key.empty_state": "状态是空的",
  "resource.phone.missing_phone_number": "缺少电话号码",
  "resource.phone.please.provide.existing.phone.number": "请提供现有的电话号码",
  "resource.phone.empty_phone_number": "电话号码是空的",
  "resource.phone.missing_verification_code": "缺少验证码",
  "resource.phone.empty_verification_code": "验证码是空的",
  // peatio
  "account.currency.doesnt_exist": "目前不存在",
  "account.deposit.invalid_state": "无效的充值状态",
  "account.deposit.non_integer_limit": "输入的值不能解析成整数",
  "account.deposit.invalid_limit": "无效的限制",
  "account.deposit.non_positive_page": "页码的值必须是正值",
  "account.deposit.empty_txid": "Txid 是空的",
  "account.deposit_address.invalid_address_format": "无效的充值地址格式",
  "account.deposit_address.doesnt_support_cash_address_format":
    "不支持的现金地址格式",
  "account.withdraw.non_integer_limit": "值不能解析成整数",
  "account.withdraw.invalid_limit": "无效的限制值",
  "account.withdraw.non_positive_page": "页码的值必须是正值",
  "account.withdraw.non_integer_otp": "身份验证码不能解析为整数",
  "account.withdraw.empty_otp": "身份验证码是空的",
  "account.withdraw.empty_rid": "Rid 是空的",
  "account.withdraw.non_decimal_amount": "数量的值不能解析成十进制",
  "account.withdraw.non_positive_amount": "数量的值必须为正",
  "account.deposit.not_permitted": "电话验证后才允许充值",
  "account.withdraw.not_permitted": "请通过相关电话和身份验证，才允许提现",
  "account.withdraw.insufficient_balance": "账户余额不足",
  "account.withdraw.invalid_amount": "无效的提现数量",
  "account.withdraw.create_error": "创建提现失败",
  "account.withdraw.invalid_otp": "无效的身份验证码",
  "account.withdraw.disabled_api": "提现API已经关闭",
  "market.market.doesnt_exist_or_not_enabled": "市场不存在",
  "market.conversion.conversion_error": "转换报价已过期",
  "market.order.invalid_state": "无效的状态",
  "market.order.invalid_limit": "无效的限价值",
  "market.order.non_integer_limit": "限价值不能解析为整数",
  "market.trade.empty_page": "页码是空的",
  "market.order.invalid_order_by": "无效的 order_by",
  "market.order.invalid_side": "无效的 order side",
  "market.order.non_decimal_volume": "交易量的值不能解析为十进制",
  "market.order.non_positive_volume": "交易量的值必须为正数",
  "market.order.invalid_type": "无效的订单类型",
  "market.order.non_decimal_price": "价格的值不能解析为十进制",
  "market.order.non_positive_price": "价格的值必须为正数",
  "market.order.non_integer_id": "交易Id无效",
  "market.order.empty_id": "交易Id是空的",
  "market.trade.non_integer_limit": "限价值不能解析为整数",
  "market.trade.invalid_limit": "无效的限价值",
  "market.trade.non_integer_timestamp": "时间戳的值不能解析为整数",
  "market.trade.empty_timestamp": "时间戳的值是空的",
  "market.trade.invalid_order_by": "无效的 order_by",
  "market.order.insufficient_market_liquidity": "市场流动性不足",
  "market.order.invalid_volume_or_price": "价格或交易量无效",
  "market.order.create_error": "创建订单出错",
  "market.order.cancel_error": "取消订单出错",
  "market.order.market_order_price": "订单没有价格",
  "market.trade.not_permitted": "请通过相关电话和身份验证，才允许交易",
  "market.account.insufficient_balance": "账户余额不足",
  "public.currency.doesnt_exist": "目前不存在",
  "public.currency.invalid_type": "无效的币种",
  "public.market.doesnt_exist": "交易对不存在",
  "public.order_book.non_integer_ask_limit": "卖出价不能解析成整数",
  "public.order_book.invalid_ask_limit": "无效的卖出价",
  "public.order_book.non_integer_bid_limit": "买入价不能解析成整数",
  "public.order_book.invalid_bid_limit": "无效的买入价",
  "public.trade.non_integer_limit": "限价值不能解析为整数",
  "public.trade.invalid_limit": "无效的限价值",
  "public.trade.non_positive_page": "页码的值必须是正值",
  "public.trade.non_integer_timestamp": "时间戳的值不能解析为整数",
  "public.trade.invalid_order_by": "无效的 order by",
  "public.market_depth.non_integer_limit": "限价值不能解析为整数",
  "public.market_depth.invalid_limit": "无效的限价值",
  "public.k_line.non_integer_period": "周期值不能解析为整数",
  "public.k_line.invalid_period": "无效的周期值",
  "public.k_line.non_integer_time_from": "值不能解析成整数",
  "public.k_line.empty_time_from": "time_from值是空的",
  "public.k_line.non_integer_time_to": "值不能解析成整数",
  "public.k_line.empty_time_to": "time_to值是空的",
  "public.k_line.non_integer_limit": "值不能解析成整数",
  "public.k_line.invalid_limit": "无效的限制",
  "server.internal_error": "内部服务器出错",
  "public.trade.tradingChart-label": "Trading Chart",
  "public.trade.marketDepth-label": "Market Depth",
  "public.trade.Chart-label-parent": "Charts",

  //NEW TRANSLATIONS START HERE
  "page.header.navbar.header": "\n",
  "page.signIn.description": "欢迎使用{exchange_name}", // Do not change exchange_name
  "page.signIn.2faRequired": "请输入google验证码",
  "page.signIn.signup": "请立即注册",
  "page.signIn.signupExists": "没有帐户？ ",
  "page.forgotPassword.description":
    "如果您忘记了密码，那么我们会通过电子邮件向您发送说明以重置密码。",
  "page.forgotPassword.back": "返回登录",
  "page.forgotPassword.signUp": "请立即注册",
  "page.forgotPassword.signUpExists": "没有帐户？ ",
  "page.body.forget_password": "忘记密码",
  "page.signUp.description": "欢迎使用{exchange_name}", // Do not change exchange_name
  "page.signUp.signin": "登录",
  "page.signUp.signinExists": "已有帐户？ ",
  "page.profile": "个人信息",
  "page.profile.profileDetailsTitle": "个人详细信息",
  "page.profile.referralTitle": "通过推荐获得收益",
  "page.profile.payableCurrencyPlaceholder": "Select your payable currency",
  "page.profile.referralDescription":
    "邀请您的朋友和家人获得奖金-贡献价值的15％。",
  "page.profile.2faTitle": "双重身份验证",
  "page.profile.2faDescription":
    "双重身份验证是一种保护您的Web帐户的方法。激活后，您不仅需要输入密码，还需要输入特殊代码。您可以通过移动应用接收此代码。即使第三者会找到您的密码，也无法使用该密码进行访问。",
  "page.profile.currentStatus": "当前状态：",
  "page.profile.kycTitle": "身份验证-KYC",
  "page.emailAddress": "电子邮件地址",
  "page.uid": "用户ID",
  "page.show": "显示",
  "page.hide": "隐藏",
  "page.payableCurrency": "Payable Currency",
  "page.body.wallet.currencyTitle": "币种",
  "page.body.wallet.currencyName": "名称",
  "page.body.wallet.availableBalance": "可用余额",
  "page.body.wallet.lockedBalance": "冻结金额",
  "page.body.wallet.actionTitle": "操作",
  "page.body.wallet.action.deposit": "充值",
  "page.body.wallet.action.withdraw": "提现",
  "page.header.navbar.2fa": "双重身份验证",
  "page.header.navbar.forgetPassword": "双重身份验证",
  "page.header.navbar.emailVerification": "电子邮件验证",
  "page.body.confirm.title": "开始身份验证",
  "page.body.confirm.subTitle": "验证您的身份",
  "success.identity.submitted": "个人资料已提交",
  "page.body.profile.content.action.signup": "注册",

  "page.body.profile.beneficiaries.header": "My Beneficiaries",
  "page.body.profile.beneficiaries.header.create": "Create new",
  "page.body.profile.beneficiaries.noBeneficiaries":
    "You have no Beneficiaries",
  "page.body.profile.beneficiaries.modal.form.selectCurrency":
    "Select Currency",
  "page.body.profile.beneficiaries.modal.form.name":
    "Beneficiary Reference Name",
  "page.body.profile.beneficiaries.modal.form.description":
    "Beneficiary description",
  "page.body.profile.beneficiaries.modal.form.address": "Beneficiary Address",
  "page.body.profile.beneficiaries.modal.form.accountNumber":
    "Beneficiary Bank Account Number",
  "page.body.profile.beneficiaries.modal.form.swift":
    "Beneficiary Bank SWIFT Code",
  "page.body.profile.beneficiaries.modal.form.fullName":
    "Beneficiary Full Name",
  "page.body.profile.beneficiaries.modal.form.submitFailed":
    "Please check if all the required fields are filled.",
  "page.body.profile.beneficiaries.modal.form.alreadyActive":
    "Beneficiary is already active you may delete it.",
  "page.body.profile.beneficiaries.modal.form.activationCode":
    "Beneficiary Activation Code",
  "page.body.profile.beneficiaries.modal.form.deleteConfirm":
    "Do you really want to delete this beneficiary?",
  "page.body.profile.beneficiaries.modal.btn.show": "Show",
  "page.body.profile.beneficiaries.modal.btn.close": "Close",
  "page.body.profile.beneficiaries.modal.btn.create": "Confirm",
  "page.body.profile.beneficiaries.modal.btn.activate": "Activate",
  "page.body.profile.beneficiaries.modal.btn.disabled": "Disable",
  "page.body.profile.beneficiaries.modal.btn.delete": "Delete",
  "page.body.profile.beneficiaries.modal.header": "Manage Beneficiaries",
  "page.body.profile.beneficiaries.modal.created_header": "Created",
  "page.body.profile.beneficiaries.table.header.currency": "Currency",
  "page.body.profile.beneficiaries.table.header.description": "Description",
  "page.body.profile.beneficiaries.table.header.name": "Name",
  "page.body.profile.beneficiaries.table.header.address": "Crypto Address",
  "page.body.profile.beneficiaries.table.header.swift": "SWIFT",
  "page.body.profile.beneficiaries.table.header.accountNumber":
    "Account Number",
  "page.body.profile.beneficiaries.table.header.fullName": "Full Name",
  "page.body.profile.beneficiaries.table.header.state": "State",
  "success.beneficiaries.fetched": "Successfully fetched Beneficiaries",
  "success.beneficiaries.created": "Beneficiary was created",
  "success.beneficiaries.updated": "Beneficiary was updated",
  "success.beneficiaries.deleted": "Beneficiary was deleted",
  "account.beneficiary.non_integer_id": "Beneficiary ID not found",
  "account.beneficiary.invalid_pin": "Invalid Beneficiary Pin",
  "account.beneficiary.invalid_state_for_withdrawal": "Invalid Beneficiary",
  "page.body.wallets.tabs.withdraw.modal.message2": " on Beneficiary",
  "page.body.wallets.tabs.withdraw.form.toggleLabel": "使用受益人",
  "page.body.wallets.tabs.withdraw.form.beneficiaryPlaceHolder": "选择受益人",
  "page.body.wallets.tabs.withdraw.form.addNewBeneficiary":
    "Add new beneficiary",
  "error.currency_already_assigned": "Currency already assigned",

  "resource.documents.already_expired":
    "Documents you trying to upload are already expired!",
  "resource.documents.invalid_format":
    "Documents must be valid and not Expired!",
  "success.beneficiaries.pinResend": "Pin Resent to your registered email.",
  "account.beneficiary.cant_resend_within_1_minute":
    "Pin already sent. Please wait 1 minute to resend the pin.",

  "page.header.navbar.otc": "OTC",
  "page.header.navbar.mining": "Mining",

  "page.trading.toolbar.progressLabel.lowest24": "Lowest 24h",
  "page.trading.toolbar.progressLabel.lastPrice": "Last Price",
  "page.trading.toolbar.progressLabel.highest24": "Highest 24h",
  "page.trading.toolbar.progressLabel.volume24": "24h Volume",
  "page.trading.toolbar.progressLabel.change": "Change",

  "page.profile.section.profile.title": "My Profile",
  "page.profile.section.referral.title": "Referral",
  "page.profile.section.accountActivity.title": "Account Activity",
  "page.profile.section.api.title": "API",
  "page.profile.section.beneficiary.title": "My Beneficiaries",

  "page.signUp.PEP.text": "PEP",
  "page.signUp.termsAndService.text": "Terms and Service",
  "page.signUp.PrivacyPolicy.text": "Privacy Policy",
  "page.footer.accountDeletionPolicy": "账户删除政策",
  "page.signUp.risks.text": "Risks Related to Cryptocurrency",

  "page.header.signUp.username": "Username *",
  "page.sigin.welcomeText": "Let’s start with Login!",
  "page.signUp.button": "SignUp",
  "page.wallets.portfolio.text": "Total Portfolio Value",
  "page.wallets.label.hideEmptyWallets": "Hide empty wallets",

  "page.history.withdraw.details": "Withdraw Details",
  "page.history.deposit.details": "Deposit Details",
  "page.markets.search.text": "Search Coins",
  "page.productMenu.home": "Home",
  "page.productMenu.p2p": "P2P",
  "page.body.wallets.min_deposit_warning":
    "The minimum deposit is currently: {min_amount} {currency}",
  "page.body.wallets.mining_deposit_warning":
    "Please do not mine directly to your deposit address, as it can change unannounced. Lost deposits will not be credited.",

  "page.body.header.markets": "Markets",
  "page.body.header.charts": "Charts",
  "page.body.header.myOrders": "My Orders",
  "page.body.header.trades": "Trades",
  "page.body.header.orders": "Orderbook",
  "page.body.header.buySell": "Buy/Sell",

  "page.body.wallets.noWallets": "No Wallets Found",

  "page.productMenu.market": "Market",
  "page.productMenu.exchange": "Exchange",
  "page.productMenu.app": "App",
  "page.productMenu.cards": "Cards",
  "page.productMenu.mining": "Mining",
  "page.productMenu.staking": "Staking",
  "page.productMenu.defi": "DeFi",
  "page.productMenu.convert": "Convert",

  "username.taken": "用户名已被占用",
  "username.too_long": "用户名太长",
  "username.too_short": "用户名太短",

  "account.update.sms_authentication_failed.resend_otp_again":
    "出了些问题，请检查代码",

  ...nationalities,
  ...nationalitiesNamesZH
}
